module.exports = __webpack_public_path__ + "static/media/arenal-volcano-1463562.cca2c5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/arenal-volcano-1463562.jpg
// module id = 790
// module chunks = 0